// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useNavigate } from "@tanstack/react-router";
import { useCallback, useMemo } from "react";
import {
  ACTIVITY_FILTER_DEFAULTS,
  type ActivityEntry,
  type ActivityFilterState,
  ActivityTimeline,
} from "@/components/shared/activity-timeline";
import { decodeFilters, encodeFilters } from "@/lib/filter-params";

function generateMockData(): ActivityEntry[] {
  const now = Date.now();
  const day = 86_400_000;
  return [
    {
      id: 1,
      timestamp: new Date(now - 0.2 * day).toISOString(),
      user: "you",
      action: "updated",
      target: "Password",
    },
    {
      id: 2,
      timestamp: new Date(now - 1.5 * day).toISOString(),
      user: "you",
      action: "created",
      target: "Passkey",
      field: "MacBook Touch ID",
    },
    {
      id: 3,
      timestamp: new Date(now - 6 * day).toISOString(),
      user: "you",
      action: "activated",
      target: "Session",
      message: "Signed in from a new device.",
    },
  ];
}

const MOCK_DATA = generateMockData();

interface ProfileActivityTabProps {
  initialFilters?: string;
}

export function ProfileActivityTab({ initialFilters }: ProfileActivityTabProps) {
  const navigate = useNavigate();
  const initial = useMemo(() => decodeFilters(initialFilters, ACTIVITY_FILTER_DEFAULTS), [initialFilters]);

  const handleFilterChange = useCallback(
    (values: ActivityFilterState) => {
      const encoded = encodeFilters(values, ACTIVITY_FILTER_DEFAULTS);
      navigate({
        to: "/profile",
        search: { t: "activity", ...(encoded ? { f: encoded } : {}) },
        replace: true,
      });
    },
    [navigate],
  );

  return <ActivityTimeline entries={MOCK_DATA} initialFilters={initial} onFilterChange={handleFilterChange} />;
}
